import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, useState, useEffect } from 'react';
import MuiTableCell from '@mui/material/TableCell';
import { styled } from '@mui/material';
// This adjustment negates the switch animation when the drag is completed
const NoAnimateTableCell = styled(MuiTableCell, {
    shouldForwardProp: prop => prop !== 'hasCompletedDrag',
}) `
  ${({ hasCompletedDrag, theme }) => !hasCompletedDrag && `
    .MuiSwitch-switchBase {
      transition: 0ms, 0ms;
      &.Mui-checked {
        filter: grayscale(100%);
        &+.MuiSwitch-track {
          background-color: ${theme.palette.common.black};
          opacity: ${theme.palette.action.disabledOpacity};
        }
      }
    }
    .MuiFormControlLabel-root .MuiTypography-root {
      color: ${theme.palette.text.secondary};
    }
  `}
`;
const TableCell = ({ children, isDragOccurring, ...muiTableCellProps }) => {
    const ref = useRef(null);
    const snapshotRef = useRef(null);
    const [hasCompletedDrag, setHasCompletedDrag] = useState(true);
    // This useEffect assists in negating the "Enabled Switch" animation on drag
    useEffect(() => {
        isDragOccurring ?
            setHasCompletedDrag(false) :
            setHasCompletedDrag(true);
    }, [isDragOccurring]);
    const getSnapshotBeforeUpdate = () => {
        if (!ref.current) {
            return null;
        }
        const isDragStarting = isDragOccurring && !snapshotRef.current?.isDragOccurring;
        if (!isDragStarting) {
            return null;
        }
        const { width, height } = ref.current.getBoundingClientRect();
        const snapshot = {
            width,
            height,
        };
        return snapshot;
    };
    useEffect(() => {
        const snapshot = getSnapshotBeforeUpdate();
        if (snapshot) {
            snapshotRef.current = {
                ...snapshot,
                isDragOccurring,
            };
            ref.current?.style.setProperty('width', `${snapshot.width}px`);
            ref.current?.style.setProperty('height', `${snapshot.height}px`);
        }
        else if (ref.current && !isDragOccurring) {
            // Clear inline styles when no snapshot and drag is finished
            ref.current.style.removeProperty('height');
            ref.current.style.removeProperty('width');
            snapshotRef.current = null;
        }
    }, [isDragOccurring]);
    const setRef = (el) => {
        ref.current = el;
    };
    return (_jsx(NoAnimateTableCell, { ...muiTableCellProps, hasCompletedDrag: hasCompletedDrag, ref: setRef, children: children }));
};
export default TableCell;
//# sourceMappingURL=TableCell.js.map